/** @format */

import * as ActionTypes from '../actionTypes';
import { axiosInstance } from '../../api/api';
import {
	INAVLID_CREDENTIALS,
	NOT_ABLE_TO_VALIDATE,
	LOGOUT_SUCCESS,
	LOGOUT_FAILURE,
} from '../../errorMessages/auth';
import { updateOperations } from './operations';
import {
	JLR_PLANT,
	OPERATIONS,
	OPERATIONS_WITH_RECEIVE_PART,
} from '../../constants';
import { parseJwt } from '../../utils/parseToken';

const insertRecivePartOperation = (operations) => {
	// Don't insert RECEIVE_PART if ENGRAVING is present
	// Because ENGRAVE flows directly to SCAN without needing RECEIVE_PART
	if (operations.includes(OPERATIONS.ENGRAVING)) {
		return;
	}

	// TRANSFER_DROP manages its own entry flow — no RECEIVE_PART needed
	if (operations.includes(OPERATIONS.TRANSFER_DROP)) {
		return;
	}

	// SFLT manages its own entry flow via the vehicle list screen — no RECEIVE_PART needed
	if (operations.includes(OPERATIONS.SFLT)) {
		return;
	}

	// WAHA station uses TRANSFER_DROP as its entry point — no RECEIVE_PART needed
	// if (operations.includes(OPERATIONS.WAHA)) {
	// 	if (!operations.includes(OPERATIONS.TRANSFER_DROP)) {
	// 		operations.unshift(OPERATIONS.TRANSFER_DROP);
	// 	}
	// 	return;
	// }

	if (operations.some((op) => OPERATIONS_WITH_RECEIVE_PART.includes(op))) {
		// If WTCL is present, we want RECEIVE_PART to be the very first operation
		// and we skip RECEIVE_SN (Scan VIN) as it's handled by Receive Part screen for this flow
		if (
			operations.includes(OPERATIONS.WTCL) ||
			operations.includes(OPERATIONS.BODY_ALIGN) ||
			operations.includes(OPERATIONS.RBT) ||
			operations.includes(OPERATIONS.PAINT_SELECT) ||
			operations.includes(OPERATIONS.PRE_CAL) ||
			operations.includes(OPERATIONS.DT) ||
			operations.includes(OPERATIONS.SHOWER) ||
			operations.includes(OPERATIONS.MAJOR_REPAIR)
		) {
			// If RECEIVE_SN is present, we don't need to insert RECEIVE_PART
			// as the user should go through the standard Scan VIN flow
			if (operations.includes(OPERATIONS.RECEIVE_SN)) {
				return;
			}

			// If RECEIVE_SN is NOT present, we insert RECEIVE_PART as the starting point
			if (!operations.includes(OPERATIONS.RECEIVE_PART)) {
				operations.unshift(OPERATIONS.RECEIVE_PART);
			}
		} else {
			// If RECEIVE_SN is present, we don't need to insert RECEIVE_PART
			// as the user should go through the standard Scan VIN flow
			if (operations.includes(OPERATIONS.RECEIVE_SN)) {
				return;
			}
			const insertIndex = operations.findIndex((op) =>
				OPERATIONS_WITH_RECEIVE_PART.includes(op),
			);
			if (!operations.includes(OPERATIONS.RECEIVE_PART)) {
				operations.splice(insertIndex, 0, OPERATIONS.RECEIVE_PART);
			}
		}
	}
};

const insertMachineOperation = (operations) => {
	if (!operations.includes(OPERATIONS.MACHINE)) {
		return [...operations, OPERATIONS.MACHINE];
	}
	return operations;
}

export const signInUser =
	(credentials, successCallback, errorCallback, conflictCallback) => (dispatch) => {
		axiosInstance
			.post('/auth/signin', {...credentials, __loginRequest: true})
			.then(({ data }) => {
				let tokenData = parseJwt(data.token);
				let plantName = '';
				if (data.plant && data.plant.name) plantName = data.plant.name;
				else if (typeof data.plant === 'string') plantName = data.plant;
				else plantName = JLR_PLANT;

				let operations = Array.isArray(tokenData.operations) ? [...tokenData.operations] : [];
				const isMrUser = (!tokenData.line && !tokenData.station) || operations.includes(OPERATIONS.MAJOR_REPAIR);
				if (isMrUser && !operations.includes(OPERATIONS.MAJOR_REPAIR)) {
					operations.push(OPERATIONS.MAJOR_REPAIR);
				}

				const signInResponse = {
					...data,
					plant: { name: plantName },
					lineId: tokenData.line || null,
					stationId: tokenData.station || null,
					username: credentials.username,
					isMobileStation: !!tokenData.isMobileStation,
					cycleTime: tokenData?.cycleTime != null ? Number(tokenData.cycleTime) : 0,
				};

				// Clear old session data to ensure fresh flow for the new user
				const stationKey = data?.station?.name?.replaceAll(/[- ]/g, '_');
				if (stationKey) {
					localStorage.removeItem(stationKey);
				}
				localStorage.removeItem('receivePart');
				localStorage.removeItem('partValidation');
				localStorage.removeItem('attribute');

				dispatch(updateUser(signInResponse));

				if (operations.length > 0 && !operations[0].startsWith(OPERATIONS.DROP)) {
					let indexOfReceivePool = operations.indexOf(
						OPERATIONS.RECEIVE_SN,
					);
					if (indexOfReceivePool !== -1)
						operations.splice(
							indexOfReceivePool + 1,
							0,
							// OPERATIONS.START_ORDER,
						);

					insertRecivePartOperation(operations);
				}
				dispatch(
					updateOperations({
						allowedOperations: operations,
						currentOperation: '',
					}),
				);

				successCallback(signInResponse);
			})
			.catch((err) => {
  const backendMessage = err?.response?.data?.message;
  const status = err?.response?.status;

  // ✅ LOGIN SCREEN KE LIYE FORCE HANDLING
  if (status === 401) {
    // Direct mismatch popup dikhao
    errorCallback(backendMessage || 'User ID or Password is mismatched');
    return;
  }

  if (status === 409) {
    if (typeof conflictCallback === 'function') {
      conflictCallback(backendMessage || 'Conflict detected');
    } else {
      errorCallback(backendMessage || 'Conflict detected');
    }
    return;
  }

  // baki sab errors
  errorCallback(backendMessage || 'Not able to validate user');
});

	};

export const logout =
	(successCallback, errorCallback) => () => {

		axiosInstance
			.post('/auth/logout')
			.then(({ data }) => {
				const successMessage = data?.message || LOGOUT_SUCCESS
				successCallback(successMessage);
			})
			.catch((err) => {
				const backendMessage = err?.response?.data?.message || LOGOUT_FAILURE;
				errorCallback(backendMessage);
			});
	};

export const updateUser = (data) => {
	const plantName = typeof data?.plant === 'string' ? data.plant : data?.plant?.name || '';
	const lineName = typeof data?.line === 'string' ? data.line : data?.line?.name || '';
	const stationName = typeof data?.station === 'string' ? data.station : data?.station?.name || '';
	const workStream = data?.line?.workStreamType || '';

	return {
		type: ActionTypes.UPDATE_TOKEN,
		payload: {
			token: data?.token || '',
			plant: plantName,
			line: lineName,
			lineId: data?.lineId || null,
			station: stationName,
			stationId: data?.stationId || null,
			isMobileStation: !!data?.isMobileStation,
			isAuthenticated: Boolean(data?.token && data.token.length > 0),
			username: data?.username || '',
			workStreamType: workStream,
			cycleTime: data?.cycleTime != null ? Number(data.cycleTime) : 0,
		},
	};
};
